import { Modal, getClassNameFactory, Button, Link } from '@dcl/ui';
import React from 'react';
import { IContactHubModalProps } from './ContactHubModalTypes';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import { contactType } from '../../ContactHubTypes';
import {
  ContactHubEmailSupport,
  ContactHubMultiSupport,
} from '@digital-csp/help-center-shared';
import './ContactHubModal.css';

const ContactHubModal = (props: IContactHubModalProps): React.ReactElement => {
  const {
    type,
    openModalButtonText,
    modalTitle,
    modalSubTitle,
    dropdownItems,
    dropdownLabel,
    modalCloseButtonLabel,
    emailSupportItems,
  } = props;
  const getClassName = getClassNameFactory(ContactHubModal.displayName);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const onModalClose = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const renderSupportItems = (type: string) => {
    if (type === contactType.phone) {
      return (
        <ContactHubMultiSupport
          dropdownLabel={dropdownLabel}
          dropdownItems={dropdownItems}
          subHeaderLabel={modalSubTitle}
        />
      );
    } else if (type === contactType.email) {
      return emailSupportItems?.map((emailItem, index) => {
        const keyValue = `${emailItem.emailId}-${index + 1}`;
        return (
          <div
            key={keyValue}
            className={getClassName({ descendantName: 'emailList' })}
          >
            <ContactHubEmailSupport
              emailId={emailItem.emailId}
              emailDisplayText={emailItem.emailLabel}
              emailDescription={emailItem.emailText}
              boldText
            />
          </div>
        );
      });
    }
    return null;
  };

  return (
    <div className={getClassName()}>
      <button
        className={getClassName({ descendantName: 'link' })}
        onClick={openModal}
      >
        <Link data-testid={'openModalButton'} type={LinkTypes.INLINE}>
          {openModalButtonText}
        </Link>
      </button>
      {isModalOpen ? (
        <Modal
          className={getClassName({ descendantName: 'modalWrapper' })}
          headerId={'ContactHub-modal'}
          closeButtonAriaLabel={'ContactHubModalClose'}
          closeThisComponent={onModalClose}
          headerTitle={modalTitle}
        >
          <div className={getClassName({ descendantName: 'multiSupportList' })}>
            {renderSupportItems(type ?? '')}
          </div>

          <div className={getClassName({ descendantName: 'closeButton' })}>
            <Button
              kind={ButtonKind.BUTTON}
              color={ButtonColor.PRIMARY}
              onClick={onModalClose}
            >
              {modalCloseButtonLabel}
            </Button>
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

ContactHubModal.displayName = 'ContactHubModal';
export default ContactHubModal;
